import { render } from "./evaluation-python.vue?vue&type=template&id=12711eb6"
import script from "./evaluation-python.vue?vue&type=script&lang=js"
export * from "./evaluation-python.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__